
import { Component, Prop, Vue } from "vue-property-decorator";
import ScrollableBanner from "@shared/crm/components/scrollableBanner.vue";
import BookingTypeCard from "../bookingType/bookingTypeCard.vue";

@Component({
  components: {
    ScrollableBanner,
    BookingTypeCard
  },
})
export default class BookingTypesBanner extends Vue {
  @Prop({ required: true }) private bookingTypes!: any[];
  @Prop({ required: false, default: true }) private showTitle!: boolean;
  
}
